$(document).on('click','.added_btn',function() {
  const id = $(this).closest('.cart_recommend-item').find('.recomm-variant_id').val();
  const $btn = $(this);
  if (!id) return;
  $btn.prop('disabled', true);
  $.post('/cart/add.js', { id, quantity: 1 })
    .done(function () {
      refreshCartDrawer({openDrawer:false})
    })
    .fail(function (xhr) {
      console.error(xhr.responseJSON?.description || 'Add to cart failed');
      $btn.prop('disabled', false);
    });
})
$(document).on('click', '[data-add-to-cart]', function (e) {
  const $btn = $(this);
  const id = $btn.data('variant-id');
  if (!id) return;
  $btn.prop('disabled', true);
  $.post('/cart/add.js', { id, quantity: 1 })
    .done(function () {
      refreshCartDrawer({openDrawer:false})
    })
    .fail(function (xhr) {
      console.error(xhr.responseJSON?.description || 'Add to cart failed');
      $btn.prop('disabled', false);
    });
});


$(document).on('click', '[data-accordion-toggle]', function () {
  const $toggle = $(this);
  const $item = $toggle.closest('[data-accordion]');
  const $content = $item.find('[data-accordion-content]');

  $('[data-accordion]').not($item).removeClass('active')
    .find('[data-accordion-content]').stop(true, true).slideUp();

  $item.toggleClass('active');
  $content.stop(true, true).slideToggle();
});


(function () {
  function onCartReady(cart, detail, action) {
    console.log('cart action:', {action, cart, detail});
    if (action === 'add') {

    }
    if (action === 'remove') {
 
    }
    if (action === 'update') {

    }
  }


  document.addEventListener('shopify:cart:lines-update', function (event) {
    console.log({event});
    var action = event.action; 

    if (event.promise) {
      event.promise
        .then(function (result) {
          onCartReady(result.cart, result.detail, action);
        })
        .catch(function (error) {
          if (error && error.name !== 'AbortError') {
            console.warn('cart update failed', error);
          }
        });
    } else {
      onCartReady(null, event.detail, action);
    }
  });


  document.addEventListener('cart:add', function (event) {
    console.log({event});
    onCartReady(event.detail && event.detail.resource, event.detail, 'add');
  });

  document.addEventListener('cart:update', function (event) {
    var detail = event.detail || {};
    var data = detail.data || detail;
    var action = data.action || 'update';
    console.log({event});
    onCartReady(detail.resource || data, data, action);
  });
})();

document.addEventListener('click', function (e) {
  const link = e.target.closest('.custom-product-block-nav');
  if (!link) return;

  e.preventDefault();
  e.stopImmediatePropagation();

  const target = document.querySelector(link.getAttribute('href'));
  if (!target) return;

  const header = document.querySelector('header-component')?.clientHeight || 0;
  const nav = document.querySelector('.fnav-section-shop-all')?.clientHeight || 0;
  const nav_section = document.querySelector('.nav-section-shop-all')?.clientHeight || 0;
  const offset = header + nav;

  target.style.scrollMarginTop = nav_section + 'px';

  target.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
}, true);

const navLinks = document.querySelectorAll('.custom-product-block-nav');
// var offset = document.querySelector('header-component')?.clientHeight || 0 + document.querySelector('.fnav-section-shop-all')?.clientHeight || 0;
var offset = document.querySelector('.nav-section-shop-all')?.clientHeight || 0;

const observer = new IntersectionObserver(entries => {
  // offset = document.querySelector('header-component')?.clientHeight || 0 + document.querySelector('.fnav-section-shop-all')?.clientHeight || 0;
  offset = document.querySelector('.nav-section-shop-all')?.clientHeight || 0;
  entries.forEach(entry => {
    if (!entry.isIntersecting) return;

    const link = document.querySelector(
      '.custom-product-block-nav[href="#' + entry.target.id + '"]'
    );

    if (!link) return;

    navLinks.forEach(item => item.classList.remove('active'));
    link.classList.add('active');

    console.log('[NAV] Active:', entry.target.id);
  });
}, {
  rootMargin: `-${offset}px 0px -60% 0px`,
  threshold: 0
});

document.querySelectorAll('.custom-product-block').forEach(section => {
  observer.observe(section);
});

const nav_section = document.querySelector('.section.nav-section-shop-all');
if (nav_section) {
  const observer = new IntersectionObserver(([entry]) => {
    nav_section.classList.toggle('sticky-applied', entry.boundingClientRect.top <= 0);
  }, { threshold: [1] });
  observer.observe(nav_section);
}